import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from './app/auth/constants';

import { fr } from './trans/fr';
import { en } from './trans/en';


const initLang=Cookies.get(FRONT_USER_LANG_COOKIE_NAME) ?Cookies.get(FRONT_USER_LANG_COOKIE_NAME):'fr';

i18n
  .use(initReactI18next)
  .init({
    resources: { fr, en },
    keySeparator: false,
    fallbackLng: initLang,
    interpolation: { escapeValue: false },
    // debug: true,
  });

export default i18n;
